import React from "react";
import TextField from "@material-ui/core/TextField";
import { useStyles } from "../../../assets/styles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

function CustomSelectNative({ options, ...props }) {
	const classes = useStyles();
	return (
		<TextField
			classes={{ root: classes.select }}
			style={{ margin: "1em auto" }}
			select
			SelectProps={{
				native: true,
				classes: { root: classes.selectFocus },
				IconComponent: () => <ArrowDropDownIcon />,
			}}
			InputProps={{
				classes: { disabled: classes.disabled, error: classes.error },
			}}
			{...props}
		>
			{options.map((option, i) => (
				<option key={`${props.name}-${i}-${option.value}`} value={option.value}>
					{option.label}
				</option>
			))}
		</TextField>
	);
}

export default CustomSelectNative;
